<template>
  <div class="national-center-center">
    <div :style="{ width: '100%', height: '100%' }" v-if="!nodata">
      <div
        id="centerCenter"
        class="chartCanvas"
        v-loading="loading"
        :style="{ width: '100%', height: '100%' }"
      ></div>
    </div>
    <div
      class="no-data flex-center"
      v-else
      :style="{ width: '100%', height: '100%' }"
    >
      <span>暂无数据</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dataList: [],
      legendData: [],
      seriesData: [],
      show: false,
      chartData: [],
      chartSeriesData: [],
      nodata: false,
      loading: true
    };
  },
  //方法集合
  methods: {
    // 获取报表数据
    async getPondAreaCount() {
      let chartData = [];
      let chartSeriesData = [];
      let res = await this.$api.getPondAreaCount();
      console.log(res.data);
      if (res.data.length > 0) {
        this.nodata = false;
        // 设置数据
        res.data.map(item => {
          chartData.push(item.year + "-" + item.month);
          chartSeriesData.push({
            value: item.count,
            name: item.year + "-" + item.month
          });
        });
        this.chartData = chartData;
        this.chartSeriesData = chartSeriesData;
        this.$nextTick(() => {
          this.loading = false;
          this.initEchart();
        });
      } else {
        this.nodata = true;
      }
    },
    initEchart() {
      const mapChart = this.$echarts.init(
        document.getElementById("centerCenter")
      );
      if (mapChart) {
        mapChart.showLoading();
        mapChart.hideLoading();

        mapChart.setOption({
          title: {
            padding: 5,
            text: "鱼塘塘口面积(亩)",
            x: "center",
            textStyle: {
              color: "#fff",
              fontWeight: 400
            }
          },
          tooltip: {
            trigger: "axis",
            formatter: "月份：{b}<br>面积：{c}亩",
            textStyle: {
              align: "left"
            }
          },
          grid: {
            x: 80,
            y: 60,
            x2: 60,
            y2: 60,
            borderWidth: 10
          },
          lineStyle: {
            color: "#D94E5D"
          },
          xAxis: {
            type: "category",
            axisLine: {
              lineStyle: {
                color: "rgba(255, 255, 255, 1)"
              }
            },
            axisLabel: {
              color: "rgba(255,255,255,1)"
            },
            data: this.chartData
          },
          yAxis: {
            type: "value",
            axisLine: {
              lineStyle: {
                color: "rgba(255, 255, 255, 1)"
              }
            },
            axisLabel: {
              color: "rgba(255,255,255,1)"
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(61,133,223,0.2)"
              }
            }
          },
          series: [
            {
              showSymbol: false,
              data: this.chartSeriesData,
              type: "line",
              itemStyle: {
                normal: {
                  color: "#D94E5D"
                }
              }
            }
          ]
        });
        window.addEventListener("resize", function() {
          mapChart.resize();
        });
      }
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getPondAreaCount();
    this.loading = false;
    this.initEchart();
  }
};
</script>
<style lang="stylus" scoped>
.no-data {
  span {
    color: #fff;
    font-size: 0.18rem;
  }
}
.national-center-center {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  position: relative;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}
</style>
